"use client"
import classNames from "classnames";
import type { SanityReference } from "next-sanity";
import styles from "./TopHorseshoeSponsor.module.css";
import CmsImageForAssetRef from "src/components/images/CmsImageForAssetRef";
import TrackingPixel from "src/components/ads/TrackingPixel";
import { useSearchParams } from "next/navigation";
import useSsrSafeMediaQuery from "src/lib/client/useSsrSafeMediaQuery";

//#region [Props]
type TopHorseshoeSponsorProps = {
    desktopImages?: SanityReference[] | null;
    desktopMq?: string;
    clickUrl?: string | null;
};
//#endregion

//#region [Component]
export default function TopHorseshoeSponsor({ desktopImages, desktopMq = "(min-width: 540px)", clickUrl }: TopHorseshoeSponsorProps) {
    const isDesktop = useSsrSafeMediaQuery(desktopMq);

    const searchParams = useSearchParams();

    if (!desktopImages || desktopImages.length === 0) {
        return null;
    }

    const shouldDisableSponsor = searchParams.get("disableSponsor");
    if (shouldDisableSponsor === "1" || shouldDisableSponsor === "true") {
        return null;
    }

    return <div className={classNames(styles.STopHorseshoeSponsor, { [styles.isDesktop]: isDesktop })}>
        <a href={clickUrl!} className={styles.SLeftImage}>
            {desktopImages.length >= 2 && <CmsImageForAssetRef className={styles.SDesktopCmsImageForAssetRef} assetRef={desktopImages![1]._ref} alt="Sponsorat" unoptimized />}
        </a>
        <a className={styles.STopImage} href={clickUrl!}>
            <CmsImageForAssetRef className={styles.SDesktopCmsImageForAssetRef} assetRef={desktopImages![0]._ref} alt="Sponsorat" unoptimized />
            {isDesktop && <TrackingPixel className={styles.STrackingPixel} targetId="SponsorTrackingPixel" />}
        </a>
        <a className={styles.SRightImage} href={clickUrl!}>
            {desktopImages.length >= 3 && <CmsImageForAssetRef className={styles.SDesktopCmsImageForAssetRef} assetRef={desktopImages![2]._ref} alt="Sponsorat" unoptimized />}
        </a>
    </div>;
}
//#endregion